const BLUE = {
	main : "rgba(93,203,233,1)",
	light : "rgba(93,203,233,0.08)",
	shades : [
		"rgba(93,203,233,1)",
		"rgba(93,203,233,0.16)",
		"rgba(93,203,233,0.84)",
		"rgba(93,203,233,0.32)",
		"rgba(93,203,233,0.68)",
		"rgba(93,203,233,0.48)"
	]
};

const GREEN = {
	main : "",
	light : "",
	shades : [
		"rgba(134,224,75,1)",
		"rgba(134,224,75,0.16)",
		"rgba(134,224,75,0.84)",
		"rgba(134,224,75,0.32)",
		"rgba(134,224,75,0.68)",
		"rgba(134,224,75,0.48)"
	]
};

const ORANGE = {
	main : "",
	light : "",
	shades : [
		"rgba(255,152,126,1)",
		"rgba(255,152,126,0.16)",
		"rgba(255,152,126,0.84)",
		"rgba(255,152,126,0.32)",
		"rgba(255,152,126,0.68)",
		"rgba(255,152,126,0.48)"
	]
};

const PINK = {
	main : "",
	light : "",
	shades : [
		"rgba(173,139,212,1)",
		"rgba(173,139,212,0.16)",
		"rgba(173,139,212,0.84)",
		"rgba(173,139,212,0.32)",
		"rgba(173,139,212,0.68)",
		"rgba(173,139,212,0.48)"
	]
};

const PURPLE = {
	main : "#ffc306",
	light : "rgba(0,0,0,0)",
	shades : [
		"rgba(59,81,213,1)",
		"rgba(59,81,213,0.16)",
		"rgba(59,81,213,0.84)",
		"rgba(59,81,213,0.32)",
		"rgba(59,81,213,0.68)",
		"rgba(59,81,213,0.48)"
	]
};

const RED = {
	main : "",
	light : "",
	shades : [
		"rgba(255,82,79,1)",
		"rgba(255,82,79,0.16)",
		"rgba(255,82,79,0.84)",
		"rgba(255,82,79,0.32)",
		"rgba(255,82,79,0.68)",
		"rgba(255,82,79,0.48)"
	]
};

const BROWN = {
	main : "",
	light : "",
	shades : [
		"rgba(212,177,139,1)",
		"rgba(212,177,139,0.16)",
		"rgba(212,177,139,0.84)",
		"rgba(212,177,139,0.32)",
		"rgba(212,177,139,0.68)",
		"rgba(212,177,139,0.48)"
	]
};

export default {
	BLUE,
	GREEN,
	ORANGE,
	PINK,
	PURPLE,
	RED,
	BROWN
}